import { TCommunity } from './@types';

export const parseCommunity = (community: TCommunity): TCommunity => {
  return community;
};

export default {};
